/**
 * @generated SignedSource<<ebe6cb7731d0cd86a83a00e9b573d6eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamSchedule_widget$data = {
  readonly content: {
    readonly __typename: "WidgetTeamScheduleContentDaily";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily">;
  } | {
    readonly __typename: "WidgetTeamScheduleContentMonthly";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly">;
  } | {
    readonly __typename: "WidgetTeamScheduleContentSummary";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary">;
  } | {
    readonly __typename: "WidgetTeamScheduleContentWeekly";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly id: string;
  readonly overviewSize: WidgetOverviewSize;
  readonly teams: ReadonlyArray<{
    readonly color: string | null;
    readonly id: string;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetTeamSchedule_widget";
};
export type WidgetTeamSchedule_widget$key = {
  readonly " $data"?: WidgetTeamSchedule_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamSchedule_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamSchedule_widget",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily"
            }
          ],
          "type": "WidgetTeamScheduleContentDaily",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly"
            }
          ],
          "type": "WidgetTeamScheduleContentWeekly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly"
            }
          ],
          "type": "WidgetTeamScheduleContentMonthly",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary"
            }
          ],
          "type": "WidgetTeamScheduleContentSummary",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTeamSchedule",
  "abstractKey": null
};
})();

(node as any).hash = "9c1b3af1f04416125cafa2c4c576b402";

export default node;
